import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { UtilsService } from '../../services/utils.service';
import { DocumentationService } from '../../../pages/school-services/documentation/documentation.service';

declare var $: any;

@Component({
  selector: 'app-rejection-motives',
  templateUrl: './rejection-motives.component.html',
  styleUrls: ['./rejection-motives.component.scss'],
  providers: [DocumentationService]
})
export class RejectionMotivesComponent implements OnInit {

  rejectionMotives: any[];
  motives: any[];
  fcMotives: FormControl;
  fcOther: FormControl;
  constructor(
    public dialogRef: MatDialogRef<RejectionMotivesComponent>,
    private service: DocumentationService,
    private toasts: ToastrService, 
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    this.rejectionMotives = [];
    this.fcMotives = new FormControl(null, Validators.minLength(1));
    this.fcOther = new FormControl();
    this.service.getRejectionMotives().subscribe(result => {
      this.rejectionMotives = result.info;

      if(data == 23 || data == 24 || data == 25){
        this.rejectionMotives = this.rejectionMotives.filter(motive => motive.id !== 6 && motive.id !== 4 );
      }

    });
  }

  ngOnInit() {
  }

  close(){
    var _this = this;
    let other = _this.fcOther.value;
    this.motives = this.fcMotives.value;
    if(UtilsService.isNullOrWhitespace(other) && (this.motives == null || this.motives.length == 0)){
      this.toasts.error('Selecciona o captura al menos un motivo de rechazo');
      return;
    }
    $.confirm({
      title: 'Confirmación',
      content: '¿Esta seguro que desea rechazar el documento?',
      backgroundDismissAnimation: 'glow',
      useBootstrap: false,
      boxWidth: '30%',
      buttons: {
        confirm: {
          btnClass: 'btn-blue',
          text: 'Si',
          keys: ['enter', 'shift'],
          action: function () {
            _this.motives = _this.motives != null ? _this.motives : [];
            
            if(!UtilsService.isNullOrWhitespace(other)){
              _this.motives.push(_this.fcOther.value.trim());
            } 
           _this.dialogRef.close({motives: _this.motives});
          }
        },
        cancel: {
          text: 'No',
          keys: ['esc'],
          action: function () {

          }
        }
      }
    });
  }

  cancel(){
    this.dialogRef.close();
  }


}
